'use strict';

var getCookie = require('./get-cookie');

var GA_COOKIE_NAME = '_ga';

module.exports = function(data, options) {
    var googleCookie = getCookie(GA_COOKIE_NAME);

    if(!googleCookie) {
        return data;
    }
    var reg = /GA\d\.\d\.(\d+.\d+)/mi;

    var parsedGAData = googleCookie.match(reg);

    if(!parsedGAData[1]) {
        return data;
    }

    return Object.assign(data, {
        'Google Universal Analytics' : {
            clientId: parsedGAData[1]
        }
    });
};
